/* atn — all things nice: Verhalten aller atn-*-Sections (aus dem Designer-Handover).
   Jede Init-Funktion arbeitet auf einem Root und markiert erledigte Elemente, damit der
   Theme-Editor (shopify:section:load) Sections einzeln neu initialisieren kann. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(root, sel, fn) { [].slice.call(root.querySelectorAll(sel)).forEach(fn); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* Hero-Wortmarke: all things nice → atn */
  function logo(root) {
    each(root, '.logoanim', function (el) {
      if (!once(el, 'atnInit')) return;
      var words = [].slice.call(el.querySelectorAll('.w')), timers = [];
      function clearTimers() { timers.forEach(clearTimeout); timers = []; }
      words.forEach(function (w, wi) {
        var t = w.getAttribute('data-word') || ''; w.innerHTML = '';
        if (!t) return;
        var first = document.createElement('span'); first.className = 'lt'; first.textContent = t[0];
        first.style.animationDelay = (wi * 0.18) + 's'; w.appendChild(first);
        var x = document.createElement('span'); x.className = 'x';
        for (var k = 1; k < t.length; k++) {
          var l = document.createElement('span'); l.className = 'lt'; l.textContent = t[k];
          l.style.animationDelay = (wi * 0.18 + k * 0.045) + 's'; x.appendChild(l);
        }
        w.appendChild(x);
      });
      function reset() { el.classList.remove('rollgo', 'collapse', 'merge'); }
      function rearm() { el.classList.remove('rollgo'); void el.offsetWidth; el.classList.add('rollgo'); }
      function cycle() {
        timers.push(setTimeout(function () { el.classList.add('collapse', 'merge'); }, 2600));
        timers.push(setTimeout(function () { el.classList.remove('collapse', 'merge'); }, 6000));
        timers.push(setTimeout(rearm, 7200));
        timers.push(setTimeout(cycle, 8600));
      }
      function play() {
        if (reduced) { el.classList.add('collapse', 'merge'); return; }
        clearTimers(); reset(); rearm(); cycle();
      }
      play();
      el.addEventListener('click', play);
    });
  }

  /* Icons drehen sich gelegentlich; Überschriften-Icons „stempeln“ beim Hereinscrollen */
  function icons(root) {
    each(root, '.icn', function (el) {
      if (!once(el, 'atnSpin')) return;
      el.classList.add('spin');
      el.style.setProperty('--d', (9 + Math.random() * 8).toFixed(1) + 's');
      el.style.setProperty('--dl', (Math.random() * 9).toFixed(1) + 's');
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
    }, { threshold: .6 });
    each(root, '.stampin', function (el) { if (once(el, 'atnStamp')) io.observe(el); });
  }

  /* Personen-/Market-Karten klappen die Bio auf */
  function persons(root) {
    each(root, '.person', function (c) {
      if (!once(c, 'atnPerson')) return;
      c.addEventListener('click', function (e) { if (e.target.tagName !== 'A') c.classList.toggle('open'); });
    });
  }

  /* Laufende Leisten (Hero-Bilder, Namens-Laufband): laufen automatisch, lassen sich aber per
     Finger/Trackpad scrollen. Inhalt ist doppelt im Markup → bei halber Breite nahtlos zurückspringen. */
  function marquees(root) {
    each(root, '.hero3 .track, .ticker', function (el) {
      if (!once(el, 'atnMarquee')) return;
      var secs = el.classList.contains('ticker') ? 120 : 55; // Dauer für eine Inhaltslänge
      var pos = el.scrollLeft, set = pos, last = 0, hold = 0;
      function half() { return el.scrollWidth / 2; }
      function pause() { hold = Date.now() + 1800; }
      el.addEventListener('scroll', function () {
        if (Math.abs(el.scrollLeft - set) < 1.5) return; // eigener Auto-Schritt
        pause();
        var h = half();
        if (h && el.scrollLeft >= h) el.scrollLeft -= h;
        else if (h && el.scrollLeft <= 0) el.scrollLeft += h;
        pos = set = el.scrollLeft;
      }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { el.addEventListener(ev, pause, { passive: true }); });
      if (reduced) return;
      function step(t) {
        if (!el.isConnected) return;
        var dt = last ? Math.min(t - last, 64) : 0; last = t;
        var h = half();
        if (Date.now() > hold && h > el.clientWidth / 2) {
          pos += h / secs * dt / 1000;
          if (pos >= h) pos -= h;
          el.scrollLeft = pos; set = el.scrollLeft;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  /* Bild/Video-Slider in den Personen-Karten: wischen (Scroll-Snap) oder Klick blättert weiter */
  function sliders(root) {
    each(root, '.ph.slider', function (sl) {
      if (!once(sl, 'atnSlider')) return;
      var track = sl.querySelector('.slides');
      var slides = [].slice.call(sl.querySelectorAll('.slide'));
      var dots = sl.querySelector('.sdots');
      if (!track || !slides.length || !dots) return;
      slides.forEach(function (_, k) { var i = document.createElement('i'); if (k === 0) i.className = 'on'; dots.appendChild(i); });
      var di = [].slice.call(dots.children), cur = 0, t;
      function set(n) {
        n = Math.max(0, Math.min(slides.length - 1, n));
        if (n === cur) return;
        di[cur].classList.remove('on');
        var v = slides[cur].querySelector('video'); if (v) v.pause();
        cur = n; di[cur].classList.add('on');
        v = slides[cur].querySelector('video'); if (v) { v.currentTime = 0; v.play().catch(function () {}); }
      }
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { set(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
      }, { passive: true });
      sl.addEventListener('click', function (e) {
        e.stopPropagation();
        track.scrollLeft = ((cur + 1) % slides.length) * track.clientWidth;
      });
    });
  }

  /* Tageskarten drehen sich beim Hereinscrollen um */
  function flips(root) {
    var cards = [].slice.call(root.querySelectorAll('.days3 a')).filter(function (c) { return once(c, 'atnFlip'); });
    if (!cards.length) return;
    if (reduced || window.Shopify && Shopify.designMode) { cards.forEach(function (c) { c.classList.add('flip'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var k = cards.indexOf(e.target);
        setTimeout(function () { e.target.classList.add('flip'); }, 500 + k * 280);
        io.unobserve(e.target);
      });
    }, { threshold: .4 });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* Registrierung: Radio schaltet zwischen Forms-Block (kitchen party) und Checkout-Formular (workshop) */
  function register(root) {
    each(root, '[data-atn-register]', function (box) {
      if (!once(box, 'atnInit')) return;
      var panes = box.querySelectorAll('.atn-pane');
      each(box, 'input[name="what"]', function (r) {
        r.addEventListener('change', function () {
          [].forEach.call(panes, function (p) { p.hidden = p.dataset.pane !== r.value; });
        });
      });
      var f = box.querySelector('form[data-pane="workshop"]');
      if (!f) return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!box.dataset.wsOk || !box.dataset.ws) { alert(box.dataset.soldOut || 'Sorry — sold out.'); return; }
        var parts = f.elements.name.value.trim().split(/\s+/), first = parts.shift() || '', last = parts.join(' ');
        var q = new URLSearchParams();
        q.set('checkout[email]', f.elements.email.value.trim());
        q.set('checkout[billing_address][first_name]', first);
        if (last) q.set('checkout[billing_address][last_name]', last);
        window.location.href = '/cart/' + box.dataset.ws + ':1?' + q.toString();
      });
    });
  }

  /* Bestätigung nach Kundenformular (Shopify leitet mit ?customer_posted=true#<form-id> zurück) */
  function posted(root) {
    if (new URLSearchParams(location.search).get('customer_posted') !== 'true' || !location.hash) return;
    var m = root.querySelector('.atn-msg[data-for="' + location.hash.slice(1) + '"]');
    if (m) m.hidden = false;
  }

  function init(root) { logo(root); icons(root); persons(root); marquees(root); sliders(root); flips(root); register(root); posted(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
